var play_icon_default = {
  "shadow": "_1vqPC",
  "playIcon": "_93axb"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
